import { AddressComponent } from '@data-access';

/**
 * Extracts and joins short address component names for the given types.
 * Returns an empty string if payload is absent or no types match.
 */
export function getAddressPart(
  payload: AddressComponent[] | undefined,
  ...types: AddressComponentType[]
): string {
  if (!payload) return '';

  const parts = types.map((type) => payload.find((c) => c.types?.includes(type))?.shortName ?? '');

  return parts.filter(Boolean).join(', ');
}

export const AddressComponentType = {
  // Street-level
  StreetAddress: 'street_address',
  StreetNumber: 'street_number',
  Route: 'route',
  Intersection: 'intersection',
  PostBox: 'post_box',
  Room: 'room',
  Floor: 'floor',
  Parking: 'parking',

  // Neighborhood / district
  Neighborhood: 'neighborhood',
  Sublocality: 'sublocality',

  // City / town
  Locality: 'locality',
  PostalTown: 'postal_town',

  // Administrative areas
  AdminAreaLevel1: 'administrative_area_level_1',
  AdminAreaLevel2: 'administrative_area_level_2',
  AdminAreaLevel3: 'administrative_area_level_3',
  AdminAreaLevel4: 'administrative_area_level_4',
  AdminAreaLevel5: 'administrative_area_level_5',
  AdminAreaLevel6: 'administrative_area_level_6',
  AdminAreaLevel7: 'administrative_area_level_7',
  ColloquialArea: 'colloquial_area',

  // Country / postal
  Country: 'country',
  PostalCode: 'postal_code',
  PlusCode: 'plus_code',

  // Points of interest
  Premise: 'premise',
  Subpremise: 'subpremise',
  NaturalFeature: 'natural_feature',
  Airport: 'airport',
  Park: 'park',
  PointOfInterest: 'point_of_interest',
  Establishment: 'establishment',
  Landmark: 'landmark',
  BusStation: 'bus_station',
  TrainStation: 'train_station',
  TransitStation: 'transit_station',

  // Generic
  Political: 'political',
} as const;

export type AddressComponentType = (typeof AddressComponentType)[keyof typeof AddressComponentType];
